import { SearchInput } from './search-input';

export { SearchInput };
